import {OutlinedInput, Select, Box} from '@mui/material';
import styled from 'styled-components';


export const AuthorFormWrapper = styled.div`
  margin: 25px 5%;
  padding: 0 20px;
`;

export const HeaderWithBorder = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 8px;
  margin-bottom: 16px;
`;

export const HeaderContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 16px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
`;

export const ImageContainer = styled.div`
  flex: 0 0 auto;
  max-width: 400px;
`;

export const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 600px;
`;

export const Row = styled.div`
  display: flex;
  gap: 8px;
`;

export const Field = styled.div`
  flex: 1;
`;

export const StyledInput = styled(OutlinedInput)`
  & .MuiOutlinedInput-input {
    padding: 6px 12px;
    font-size: 15px;
  }
  & .MuiOutlinedInput-input::placeholder {
    font-size: 15px;
    opacity: 0.7;
  }
`;

export const StyledDescriptionInput = styled(OutlinedInput)`
  & .MuiOutlinedInput-input {
    padding: 6px 12px;
    font-size: 15px;
  }
  & .MuiOutlinedInput-input::placeholder {
    font-size: 15px;
    opacity: 0.7;
  }
`;

export const StyledSelect = styled(Select)`
  & .MuiSelect-select {
    padding: 6px 12px;
    font-size: 15px;
  }
`;

export const StyledCheckboxContainer = styled(Box)`
  display: flex;
  gap: 12px;
  align-items: center;
  font-size: 15px;
`;

export const StyledSaveButton = styled.button`
  padding: 8px;
  font-size: 14px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  &:hover {
    background-color: #115293;
  }
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;